import axios from 'axios';
import { commonReject, commonReject2 } from '../../utils/api';
import { LIBRARY_BRANDS, BRAND_ALL_OUTLETS } from './constants';

export function getBrands(params, outletId) {
  return axios
    .get(LIBRARY_BRANDS(outletId), { params, withCredentials: true })
    .catch(commonReject);
}

export function getBrandDetail(id, outletId, params?) {
  return axios
    .get(LIBRARY_BRANDS(id, outletId), { params, withCredentials: true })
    .catch(commonReject);
}

export function brandRequestWithKeywordAndType(outletId, params) {
  return axios
    .get(LIBRARY_BRANDS(outletId), { params, withCredentials: true })
    .catch(commonReject);
}

export function updateBrand(id, outletId, data, params?) {
  return axios
    .put(LIBRARY_BRANDS(outletId, id), data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function createBrand(outletId, data, params?) {
  return axios
    .post(LIBRARY_BRANDS(outletId), data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function createBrandAllOutlets(outletId, data, params?) {
  return axios
    .post(BRAND_ALL_OUTLETS(outletId), data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function deleteBrand(outletId, id, params?) {
  return axios
    .delete(LIBRARY_BRANDS(outletId, id), { params, withCredentials: true })
    .catch(commonReject2);
}
